import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicSslCertificateListParamsRaw,
	type LWApiPublicSslCertificateListResultRaw,
} from '@liquidweb-dev/club-sauce/public/ssl/certificate/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const SSL_CERTIFICATE_LIST_QUERY_KEY = '/ssl/certificate/list';

const useCertificateList = (
	params: LWApiPublicSslCertificateListParamsRaw,
	options?: UseQueryOptions<LWApiPublicSslCertificateListResultRaw, ApiErrorI>,
) =>
	useQuery({
		queryKey: [SSL_CERTIFICATE_LIST_QUERY_KEY, params],
		queryFn: () => api.ssl.certificate.apiRaw.list(params),
		...options,
	});

export default useCertificateList;
